<!--底部 Tabbar 标签栏-->
<template>
  <van-tabbar
		route
		v-model="active"
		active-color="#07c160"
		inactive-color="#333"
	>
		<van-tabbar-item icon="home-o" to="/">首页</van-tabbar-item>
		<van-tabbar-item icon="location-o" to="/dynamic/index">动态</van-tabbar-item>
		<van-tabbar-item icon="apps-o" to="/goods/category/index">分类</van-tabbar-item>
		<van-tabbar-item icon="shopping-cart-o" to="/cart/index">购物车</van-tabbar-item>
		<van-tabbar-item icon="user-o" to="/user/index">我的</van-tabbar-item>
  </van-tabbar>
</template>

<script>
import {
	Tabbar,
	TabbarItem
} from 'vant';

export default {
	components: {
		[Tabbar.name]:Tabbar,
		[TabbarItem.name]: TabbarItem
	},
  name: 'Tabbar',
	data() {
		return {
			active: 0
		}
	}
}
</script>

<style scoped>

</style>
